import './typography-mapping.css';
export var MarkdownCheckmarkBackgroundCSS = '_pym1vh5-2-0-1';
export var MarkdownHeadingCSS = '_pym1vh0-2-0-1';
export var MarkdownImageCSS = '_pym1vh4-2-0-1';
export var MarkdownListCSS = '_pym1vh1-2-0-1';
export var MarkdownListItemCSS = '_pym1vh2-2-0-1';
export var MarkdownParagraphCSS = '_pym1vh3-2-0-1';